import React from 'react';
import PropTypes from 'prop-types';
import Select from '@/components/molecules/Select';
import { useTranslation } from 'react-i18next';

const EnquirySelector = ({ items, value, onChange }) => {
  const { t } = useTranslation();
  const onChangeHandler = e => {
    const enquiry = items.find(item => item.code === e.currentTarget.value);
    onChange(enquiry || {});
  };

  if (items.length === 0) return null;

  return (
    <div className='dln-contactUs__enquiryWrapper'>
      <Select
        id='enquiryType'
        label=''
        placeholderLabel={t('form.select.enquiry.types.label')}
        value={value}
        values={items}
        onChange={onChangeHandler}
        fieldCode='code'
        fieldName='displayName'
      />
    </div>
  );
};

EnquirySelector.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape()),
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

EnquirySelector.defaultProps = {
  items: [],
  value: '',
};

export default EnquirySelector;
